import React from 'react';

interface VideoPlayerProps {
  videoId: string;
  className?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  videoId,
  className = '',
}) => {
  return (
    <div className={`video-player-container ${className}`}>
      <div className="video-wrapper">
        <iframe
          src={`https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479`}
          title="ColorCache Demo Video"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          className="video-iframe"
          style={{ border: 'none' }}
        />
      </div>
    </div>
  );
};

export default VideoPlayer;
